"use client";

import React, { useEffect, useState } from "react";

export default function Announcement() {
  const [announcement, setAnnouncement] = useState("");
  const [language, setLanguage] = useState<"en" | "tr">(() => {
    if (typeof window !== 'undefined') {
      const storedLanguage = localStorage.getItem("selectedLanguage");
      return (storedLanguage === "en" || storedLanguage === "tr") ? storedLanguage : "en";
    }
    return "en";
  });
  const [loading, setLoading] = useState(true);

  // Listen for language changes
  useEffect(() => {
    const handleLanguageChange = () => {
      const storedLanguage = localStorage.getItem("selectedLanguage");
      if (storedLanguage === "en" || storedLanguage === "tr") {
        setLanguage(storedLanguage);
      }
    };

    window.addEventListener('storage', handleLanguageChange);
    window.addEventListener('languageChange', handleLanguageChange);
    
    return () => {
      window.removeEventListener('storage', handleLanguageChange);
      window.removeEventListener('languageChange', handleLanguageChange);
    };
  }, []);

  // Fetch announcement with cache busting
  useEffect(() => {
    async function fetchAnnouncement() {
      if (!language) return;
      
      setLoading(true);
      try {
        const timestamp = new Date().getTime();
        const res = await fetch(`/api/announcements?language=${language}&t=${timestamp}`, {
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Pragma': 'no-cache'
          }
        });

        if (!res.ok) {
          throw new Error(`API error: ${res.status}`);
        }

        const data = await res.json();
        setAnnouncement(data.announcement || "");
      } catch (error) {
        console.error("Fetch error:", error);
        setAnnouncement("");
      } finally {
        setLoading(false);
      }
    }

    fetchAnnouncement();
  }, [language]);

  if (loading || !announcement.trim()) {
    return null;
  }

  return (
    <div className="w-full bg-brown-200 overflow-hidden text-left">
      <div className="announcement-track whitespace-nowrap">
        {Array(50)
          .fill(announcement)
          .map((text, index) => (
            <span
              key={index}
              className="inline-block px-4 text-brown-800 text-sm uppercase"
            >
              {text}
            </span>
          ))}
      </div>
    </div>
  );
}
